import { createIcon } from "@chakra-ui/icons";

export const SmallArrowDownIcon = createIcon({
  displayName: "SmallArrowDownIcon",
  viewBox: "0 0 6 6",
  d: "m.248 2.49 2.164 2.255c.326.34.852.34 1.178 0L5.754 2.49C6.281 1.941 5.904 1 5.161 1H.833C.089 1-.28 1.94.248 2.49Z",
  defaultProps: {
    width: "6px",
    height: "6px",
  },
});
